import React from 'react';
import { Spin, Empty, Button, Row, Col, Card, Statistic, Table } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import BrandNetworkGraph from '../BrandNetworkGraph';
import { getBrandDetailsColumns } from '../../config/tableColumns';

interface BrandCompetitionTabProps {
  networkData: any;
  brandDetails: any[];
  loading: boolean;
  brandDetailsLoading: boolean;
  onGenerate: (isManual: boolean) => void;
  onRefreshDetails: () => void;
}

/**
 * 品牌竞争Tab组件
 * 展示品牌网络图、统计卡片和品牌详细数据表格
 */
export const BrandCompetitionTab: React.FC<BrandCompetitionTabProps> = ({
  networkData,
  brandDetails,
  loading,
  brandDetailsLoading,
  onGenerate,
  onRefreshDetails,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', minHeight: '200px' }}>
        <Spin size="large" tip="正在加载品牌网络数据...">
          <div style={{ minHeight: 100 }} />
        </Spin>
      </div>
    );
  }

  if (!networkData || !networkData.nodes || networkData.nodes.length === 0) {
    return (
      <Empty 
        description={networkData?.message || "暂无品牌竞争数据"} 
        style={{ padding: '50px' }}
      >
        <Button type="primary" onClick={() => onGenerate(true)} icon={<ReloadOutlined />}>
          生成品牌竞争数据
        </Button>
      </Empty>
    );
  }

  return (
    <div style={{ padding: '20px 0' }}>
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card>
            <Statistic
              title="品牌总数"
              value={networkData.total_brands || 0}
              prefix="🏢"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="竞争关系数"
              value={networkData.edges?.length || 0}
              prefix="⚔️"
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="显示品牌数"
              value={networkData.displayed_brands || 0}
              valueStyle={{ fontSize: '20px' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 品牌网络图 */}
      <BrandNetworkGraph
        nodes={networkData.nodes || []}
        edges={networkData.edges || []}
      />
      
      {/* 品牌详细数据表格 */}
      <Card 
        title="品牌详细数据" 
        style={{ marginTop: 24 }}
        extra={
          <Button 
            icon={<ReloadOutlined />} 
            onClick={onRefreshDetails}
            loading={brandDetailsLoading}
          >
            刷新数据
          </Button>
        }
      >
        <Table
          dataSource={brandDetails}
          loading={brandDetailsLoading}
          rowKey="brand"
          pagination={{
            pageSize: 10,
            showTotal: (total) => `共 ${total} 个品牌`,
          }}
          scroll={{ x: 1400 }}
          columns={getBrandDetailsColumns(brandDetails)}
        />
      </Card>
    </div>
  );
};

